var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clickable",on:{"click":function($event){return _vm.$emit('node-remove')}}},[_c('i',{staticClass:"mdi mdi-close-circle-outline"})])}
var staticRenderFns = []

export { render, staticRenderFns }